<template>
  <app-layout v-if="!isMaintenance">
    <div v-if="!loading">
      <router-view />
    </div>
    <main :class="`tw-min-w-[320px] tw-rounded-md bg-main tw-relative tw-overflow-hidden`" v-else>
      <div
        class="tw-h-[75vh] tw-flex tw-justify-center tw-items-center"
        :style="{
          backgroundImage: `url(${require('@/assets/images/CasinoLoadingScreen.jpg')})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center center',
        }"
      >
        <div class="bg-loading tw-inset-0 tw-absolute"></div>
        <div
          :style="`background: url(${require('@/assets/images/LoadingCasino.png')}) 0 0 no-repeat; background-size: auto 1000px;`"
          class="tw-z-20 tw--mt-24 casino-loading"
        ></div>
      </div>
    </main>
    <template v-slot:footer>
      <Footer v-show="showFooter" />
    </template>
  </app-layout>
  <maintenance-layout v-else :loading="loading" :isMaintenance="isMaintenance"></maintenance-layout>
</template>
<script>
import Footer from "./components/Footer.vue";
import { mapActions, mapMutations } from "vuex";
export default {
  data: () => ({
    showFooter: true,
    isMaintenance: false,
    loading: true,
  }),
  components: { Footer },
  async beforeMount() {
    const response = await this.userValidate();
    if (response && response.data && !response.data.success) {
      this.$cookies.remove("_token");
    }

    const resp = await this.checkMaintenance();
    this.isMaintenance = resp.isMaintenance;
    this.$store.commit("game/setFlipmasterSettings", resp.flipmasterSettings);
    if (this.isMaintenance) {
      const response = await this.playerInit();
      if (response.success) {
        if (response.data && response.data.allow_in_maintenance) {
          this.isMaintenance = false;
        }
      }
    }
    this.loading = false;
  },
  watch: {
    "$route.name": function () {
      if (this.$route.name != "Play") {
        this.setPlayBackground(false);
        this.setPlayGame(null);
      }

      if (this.$route.name != "Play") {
        this.setPlayBackground(false);
        this.setPlayGame(null);
      }
    },
  },
  methods: {
    ...mapActions("user", ["userValidate"]),
    ...mapMutations("game", ["setPlayBackground", "setPlayGame"]),
    ...mapActions("game", ["checkMaintenance", "playerInit"]),
  },
  metaInfo: {
    title: "2EZ.BET Casino",
    titleTemplate: "%s: Live Casino , Casino Arcade",
  },
};
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

#nprogress .bar {
  background: #d4af37 !important;
}

[v-cloak] {
  display: none;
}

.bg-loading {
  background: rgb(0, 0, 0);
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(23, 22, 21, 1) 97%);
}

.casino-loading {
  margin-top: 10px;
  width: 200px;
  height: 170px;
  cursor: pointer;
  background-size: cover;
  color: #d7d7d7;
  font-weight: bold;
  text-align: center;
  border-radius: 5px;
  transition: box-shadow 0.1s ease-in;
  overflow: hidden;
  animation: casino-animate 4s steps(6) infinite;
}

.casino-loading:hover {
  filter: drop-shadow(0px 0px 5px rgba(213, 4, 1, 0.5));
}

@keyframes casino-animate {
  0% {
    background-position: 0 0px;
    transition-timing-function: ease;
  }

  /* 25%{
        background-position: 0 -150px;
        transition-timing-function: ease;
    }
    50%{
        background-position: 0 -200px;
        transition-timing-function: ease;
    }
    75%{
        background-position: 0 -250px;
        transition-timing-function: ease;
    } */
  100% {
    background-position: 0 -990px;
    transition-timing-function: ease;
  }
}
</style>
